import { Component } from '@theme/component';

/**
 * Complementary products section: hides the carousel arrows when all products fit without scrolling.
 * The slideshow's own auto-hide only covers the dots/counter bar, not the side arrows.
 *
 * @extends {Component}
 */
class ComplementaryProducts extends Component {
  #resizeObserver = new ResizeObserver(() => this.#updateArrows());

  connectedCallback() {
    super.connectedCallback();
    this.#observeCarousels();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
  }

  /**
   * The product list carousels (desktop and mobile), excluding the image sliders inside product cards.
   * @returns {HTMLElement[]}
   */
  get #carousels() {
    return Array.from(this.querySelectorAll('slideshow-component.resource-list__carousel'));
  }

  #observeCarousels() {
    this.#resizeObserver.disconnect();
    for (const carousel of this.#carousels) {
      const scroller = carousel.querySelector(':scope > slideshow-container > slideshow-slides');
      if (scroller) this.#resizeObserver.observe(scroller);
    }
    this.#updateArrows();
  }

  #updateArrows() {
    for (const carousel of this.#carousels) {
      const scroller = carousel.querySelector(':scope > slideshow-container > slideshow-slides');
      const arrows = carousel.querySelector(':scope > slideshow-container > slideshow-arrows');
      if (!(scroller instanceof HTMLElement) || !(arrows instanceof HTMLElement)) continue;

      // A hidden carousel (e.g. the mobile one on desktop) has no width; leave it alone
      if (!scroller.clientWidth) continue;
      arrows.hidden = scroller.scrollWidth <= scroller.clientWidth + 1;
    }
  }
}

if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', ComplementaryProducts);
}
